import { render, staticRenderFns } from "./List-Banners.vue?vue&type=template&id=6679b0fd&scoped=true"
import script from "./List-Banners.vue?vue&type=script&lang=js"
export * from "./List-Banners.vue?vue&type=script&lang=js"
import style0 from "./List-Banners.vue?vue&type=style&index=0&id=6679b0fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679b0fd",
  null
  
)

export default component.exports